import React, { useContext } from "react";
import { VideoContext } from '../context/VideoContext';

const BackToTop = () => {
  const { lastEvent } = useContext(VideoContext);
  // Scroll to the top of the document smoothly
  const scrollToTop = (e) => {
    e.preventDefault();
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    let el = document.querySelector("a.introScreenCallout").focus();
    if (el) {
      if (el && lastEvent === "mousedown") {
        el.focus();
      } else {
        el.contentEditable = true;
        el.focus();
        el.contentEditable = false;
      }
    }
  };

  const style = {
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5px",
  };

  return (
    <div>
      <a href="/back-to-top" aria-labelledby="back-to-top-label" className="flex flex-row justify-center items-center gap-2 underline decoration-white" onClick={scrollToTop}>
        <span id="back-to-top-label" className="text-white">Back to top</span>
        <svg role="img" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14">
          <title>arrow pointing up</title>
          <g data-name="Group 3694" transform="translate(-1092.708 -709)">
            <circle data-name="Ellipse 58" cx="7" cy="7" r="7" transform="translate(1092.708 709)" style={{fill:"#f56060"}} />
            <path data-name="Path 987" d="m-11001.829 3241.9 3.5-2.772 3.476 2.772" transform="translate(12098.222 -2524.983)" style={style} />
          </g>
        </svg>
      </a>
    </div>
  );
};

export default BackToTop;
